import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { logout } from '../../api';
import './ParentLayout.css';

function ParentLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('parentSidebarCollapsed') === 'true';
  });
  const { token, clearAuth } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    const newState = !collapsed;
    setCollapsed(newState);
    localStorage.setItem('parentSidebarCollapsed', newState);
  };

  const handleLogout = async () => {
    try {
      await logout(token);
    } catch (err) {
      // Ignore
    }
    clearAuth();
    navigate('/');
  };

  return (
    <div className={`parent-layout ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <nav className="parent-sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={collapsed ? '/logo_round.svg' : '/logo.svg'} alt="HAILP" className="sidebar-logo-img" />
          </div>
          <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle menu">
            <svg viewBox="0 0 24 24" fill="currentColor">
              {collapsed ? (
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
              ) : (
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              )}
            </svg>
          </button>
        </div>
        <div className="sidebar-menu">
          <NavLink to="/app" end className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
            </svg>
            <span>Abonnements</span>
          </NavLink>
          <NavLink to="/app/enfants" className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
            </svg>
            <span>Mes enfants</span>
          </NavLink>
        </div>
        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={handleLogout}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            <span>Déconnexion</span>
          </button>
        </div>
      </nav>
      <main className="parent-main">
        <Outlet />
      </main>
    </div>
  );
}

export default ParentLayout;
